import { ZendeskAPI } from 'react-zendesk';
import { User } from '../models/User';

export const configureZendesk = (user: User, searchText: string): boolean => {
    ZendeskAPI('webWidget', 'setLocale', user.language);
    const zE = window['zE'];
    if (zE !== undefined) {
        zE('webWidget', 'prefill', {
            name: { value: user.firstName },
            email: { value: user.email },
        });
        zE('webWidget', 'helpCenter:setSuggestions', { search: searchText });
        return true;
    }
    return false;
};
export const zendeskSettings = {
    color: {
        theme: '#000',
    },
};
